// extracted by mini-css-extract-plugin
export default {"description":"plusButtonGroup_description__4FeDC"};